import { dividirNegrito, interpretarMarkdown } from "./interpretarMarkdown";

function Texto({ texto }) {
  return dividirNegrito(texto).map((parte, indice) =>
    parte.negrito ? (
      <strong key={indice} className="font-semibold text-gray-900">
        {parte.texto}
      </strong>
    ) : (
      <span key={indice}>{parte.texto}</span>
    ),
  );
}

function Lista({ bloco }) {
  const Tag = bloco.ordenada ? "ol" : "ul";
  const estilo = bloco.ordenada ? "list-decimal" : "list-disc";

  return (
    <Tag className={`${estilo} space-y-2 pl-6 text-base leading-relaxed text-gray-700`}>
      {bloco.itens.map((item, indice) => (
        <li key={indice}>
          <Texto texto={item.texto} />
          {item.filhos.length > 0 && (
            <ul className="mt-1.5 list-disc space-y-1 pl-5">
              {item.filhos.map((filho, indiceFilho) => (
                <li key={indiceFilho}>
                  <Texto texto={filho} />
                </li>
              ))}
            </ul>
          )}
        </li>
      ))}
    </Tag>
  );
}

function Tabela({ bloco }) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse text-left text-sm text-gray-700">
        <thead>
          <tr>
            {bloco.cabecalho.map((celula, indice) => (
              <th
                key={indice}
                className="border-b border-gray-200 bg-gray-50 px-3 py-2 font-semibold text-gray-900"
              >
                <Texto texto={celula} />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {bloco.linhas.map((linha, indiceLinha) => (
            <tr key={indiceLinha}>
              {linha.map((celula, indice) => (
                <td key={indice} className="border-b border-gray-100 px-3 py-2 align-top">
                  <Texto texto={celula} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function Bloco({ bloco }) {
  if (bloco.tipo === "subtitulo") {
    return <h4 className="pt-2 text-base font-semibold text-blue-700">{bloco.texto}</h4>;
  }
  if (bloco.tipo === "lista") {
    return <Lista bloco={bloco} />;
  }
  if (bloco.tipo === "tabela") {
    return <Tabela bloco={bloco} />;
  }
  return (
    <p className="text-base leading-relaxed text-gray-700">
      <Texto texto={bloco.texto} />
    </p>
  );
}

const TITULOS_DE_AVISO = ["cuidado", "ponto de atenção", "pontos de atenção"];

function Secao({ secao }) {
  const tituloEmMinusculas = (secao.titulo || "").toLowerCase();
  const ehAviso = TITULOS_DE_AVISO.some((aviso) =>
    tituloEmMinusculas.startsWith(aviso),
  );
  const classeCaixa = ehAviso
    ? "rounded-lg border border-amber-200 bg-amber-50 p-4"
    : "";

  return (
    <section className={`space-y-3 ${classeCaixa}`.trim()}>
      {secao.titulo && (
        <h3 className="text-lg font-semibold text-gray-900">{secao.titulo}</h3>
      )}
      {secao.blocos.map((bloco, indice) => (
        <Bloco key={indice} bloco={bloco} />
      ))}
    </section>
  );
}

export default function MarkdownSimples({ texto }) {
  const { secoes } = interpretarMarkdown(texto);

  return (
    <div className="space-y-6">
      {secoes.map((secao, indice) => (
        <Secao key={indice} secao={secao} />
      ))}
    </div>
  );
}
